export default "__VITE_ASSET__PljhSWmX__"